import { render, staticRenderFns } from "./yifang.vue?vue&type=template&id=4584b77e&scoped=true"
import script from "./yifang.vue?vue&type=script&lang=js"
export * from "./yifang.vue?vue&type=script&lang=js"
import style0 from "./yifang.vue?vue&type=style&index=0&id=4584b77e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4584b77e",
  null
  
)

export default component.exports